import React, { PropTypes, Component } from 'react'
import { fromJS } from 'immutable'
import { Control } from 'react-redux-form/immutable'
import Select from 'react-select'

import errBlock from 'components/ErrBlock'

class Multiple extends Component {

  _onChange = (value) => {
    if (!value) {
      this.props.onChange(fromJS([]))
    } else {
      const ids = value.split(',').map((id) => Number(id))
      this.props.onChange(fromJS(ids))
    }
  }

  render() {
    const { options, value } = this.props

    return (
      <Select
        options={options}
        onChange={this._onChange}
        value={value.toJS()}
        multi
        simpleValue
      />
    )
  }
}

const InputSelectMultiple = ({ model, label, options, required, ...props }) => (
  <div>
    <label htmlFor={label}>{label} {required && <span className="req">*</span>}</label>
    <Control
      model={model}
      component={Multiple}
      controlProps={{options}}
      mapProps={{
        value: (props) => props.modelValue,
        onChange: (props) => props.onChange,
      }}
      {...props}
    />
    {errBlock(model)}
  </div>
)

InputSelectMultiple.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
}

export default InputSelectMultiple



// WEBPACK FOOTER //
// ./src/components/InputSelectMultiple/index.js